module.exports = __webpack_public_path__ + "videos/ipad-hero_en.1a56667.mp4";